import { useQuery } from '@tanstack/react-query'

import { Payment } from '@/modules/checkout/_core/domain/entities'
import { PaymentLinkByIdServiceTypes } from '@/modules/checkout/_core/services/payment-link-by-id'
import {
  PayGenerateOption,
  payLinkById,
} from '@/modules/checkout/actions/payment'

import { payGenerateKey } from './key'

export const usePayGenerate = (
  type: PayGenerateOption,
  id: string,
  paymentType?: number,
) => {
  return useQuery<
    Payment | undefined,
    PaymentLinkByIdServiceTypes.PaymentErrorResponse
  >({
    queryKey: payGenerateKey(type, id, paymentType),
    queryFn: async () => {
      return await payLinkById({ id, type, paymentType: paymentType! })
    },
    enabled: Boolean(paymentType),
  })
}
